// E-Mail-Kontext-Panel (collapsible, ueber dem PDF): Betreff/Absender/Empfangszeit + Klartext-
// Body, NUR wenn das Dokument aus einer Mail stammt (doc.emailContext, s. BE-1 GET /documents/:id-
// Erweiterung — mail_message_id verknuepft). Solange BE-1 dieses Feld noch nicht liefert, ist
// emailContext einfach undefined -> Panel bleibt unsichtbar (sauber degradieren, kein Crash).

import React from 'react';
import { Mail, ChevronDown, ExternalLink } from 'lucide-react';
import { Card, fmtDate } from '../ui';

const AbEmailContextPanel = ({ isDarkMode, t, emailContext, mailMessageId, onOpenMail }) => {
  if (!emailContext) return null;
  const textMuted = isDarkMode ? 'text-white/50' : 'text-slate-500';
  const textMain = isDarkMode ? 'text-white/85' : 'text-slate-800';

  return (
    <Card isDarkMode={isDarkMode} className="!p-0 overflow-hidden">
      <details>
        <summary className={`list-none flex items-center justify-between gap-2 px-5 py-4 cursor-pointer select-none ${isDarkMode ? 'hover:bg-white/[0.03]' : 'hover:bg-slate-50'}`}>
          <span className={`flex items-center gap-2 text-sm font-semibold ${textMain}`}>
            <Mail className="w-4 h-4" />{t('abPdf.emailContextTitle')}
            {emailContext.senderAddress && <span className={`font-normal ${textMuted}`}>— {emailContext.senderAddress}</span>}
          </span>
          <span className={`flex items-center gap-2 text-xs ${textMuted}`}>
            {emailContext.receivedAt && fmtDate(emailContext.receivedAt)}
            <ChevronDown className="w-4 h-4" />
          </span>
        </summary>
        <div className="px-5 pb-4 space-y-2">
          {emailContext.subject && (
            <p className={`text-sm ${textMain}`}><strong>{t('abPdf.emailSubjectLabel')}:</strong> {emailContext.subject}</p>
          )}
          {typeof onOpenMail === 'function' && mailMessageId != null && (
            <button type="button" onClick={() => onOpenMail(mailMessageId)}
              className={`inline-flex items-center gap-1.5 text-xs font-medium ${isDarkMode ? 'text-indigo-300 hover:text-indigo-200' : 'text-indigo-600 hover:text-indigo-700'}`}>
              <ExternalLink className="w-3.5 h-3.5" />{t('abPdf.emailOpenMailButton')}
            </button>
          )}
          {emailContext.bodyText ? (
            <pre className={`text-xs whitespace-pre-wrap font-mono rounded-xl p-3 max-h-72 overflow-auto ${isDarkMode ? 'bg-black/30 text-white/70' : 'bg-slate-50 text-slate-600'}`}>
              {emailContext.bodyText}
            </pre>
          ) : (
            <p className={`text-xs ${textMuted}`}>{t('abPdf.emailBodyEmpty')}</p>
          )}
        </div>
      </details>
    </Card>
  );
};

export default AbEmailContextPanel;
